import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { FlagBR, FlagUS, FlagES } from "@/components/Flags";
import { useLanguage } from "@/i18n/LanguageContext";

export const LANGS = [
  { id: "pt", label: "Português", Flag: FlagBR },
  { id: "en", label: "English", Flag: FlagUS },
  { id: "es", label: "Español", Flag: FlagES },
];

const LanguageSwitcher = () => {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const current = LANGS.find((l) => l.id === lang) || LANGS[0];

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        data-testid="language-switcher-button"
        onClick={() => setOpen((v) => !v)}
        aria-label={t.nav.language}
        className="flex items-center gap-2 rounded-full border border-emerald-500/25 px-3.5 py-2 transition-colors duration-300 hover:border-emerald-400/60"
      >
        <current.Flag className="h-3.5 w-5" />
        <span className="font-mono-tech text-[10px] font-bold uppercase tracking-[0.2em] text-emerald-300">
          {current.id}
        </span>
        <ChevronDown className={`h-3.5 w-3.5 text-emerald-400 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 top-full z-50 mt-2 w-44 overflow-hidden rounded-2xl border border-emerald-500/25 bg-[#0F2117] shadow-2xl shadow-black/40"
        >
          {LANGS.map(({ id, label, Flag }) => (
            <button
              key={id}
              data-testid={`language-option-${id}`}
              onClick={() => {
                setLang(id);
                setOpen(false);
              }}
              className={`flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors duration-200 ${
                lang === id
                  ? "bg-emerald-500/15 text-emerald-300"
                  : "text-slate-300 hover:bg-emerald-500/10 hover:text-emerald-200"
              }`}
            >
              <Flag className="h-3.5 w-5 shrink-0" />
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
